import Checkbox from '../spark/Checkbox';
import React, { ReactNode } from "react";

import BootstrapTable from "./BootstrapTable";

interface Column<T> {
  caption?: ReactNode;
  dataField?: keyof T;
  renderHeader?: () => ReactNode;
  renderCell?: (data: T, index?: number) => ReactNode;
  width?: number | string;
  minWidth?: number | string;
  maxWidth?: number | string;
  align?: "left" | "center" | "right" | undefined;
  sticky?: boolean;
}

interface LegacyMuiDatatableProps<T> {
  size?: "small" | "normal" | "large";
  showPagination?: boolean;
  showCheckBox?: boolean;
  columns: Column<T>[];
  data: T[];
  noDataTitle?: string;
  minHeight?: string | number;
  maxHeight?: string | number;
  groupByField?: keyof T | null;
  defaultGroupsCollapsed?: boolean;
  renderGroupTitle?: (groupKey: string, groupData: T[]) => ReactNode;
}

function LegacyMuiDatatable<T>({
  columns,
  data,
  showPagination = false,
  showCheckBox = false,
  minHeight = "60px",
  maxHeight = "720px",
  noDataTitle = "Khong co du lieu",
}: LegacyMuiDatatableProps<T>) {
  const mappedColumns: any[] = [];

  if (showCheckBox) {
    mappedColumns.push({
      key: "checkbox",
      header: <Checkbox size="small" disabled />,
      width: 52,
      minWidth: 52,
      maxWidth: 52,
      align: "center",
      sticky: true,
      render: () => <Checkbox size="small" disabled />,
    });
  }

  columns.forEach((column, index) => {
    const autoSticky =
      !!column.sticky ||
      column.caption === "STT" ||
      column.dataField === ("CMND" as keyof T) ||
      column.dataField === ("Ho_ten" as keyof T);

    mappedColumns.push({
      key: String(column.dataField ?? index),
      header: column.renderHeader ? column.renderHeader() : column.caption ?? "",
      field: column.dataField,
      width: column.width,
      minWidth: column.minWidth ?? column.width,
      maxWidth: column.maxWidth ?? column.width,
      align: column.align,
      sticky: autoSticky,
      render: column.renderCell ? (row: T, rowIndex: number) => column.renderCell!(row, rowIndex) : undefined,
    });
  });

  return (
    <BootstrapTable
      columns={mappedColumns}
      data={data}
      minHeight={minHeight}
      maxHeight={maxHeight}
      emptyText={noDataTitle}
      showPagination={showPagination}
      initialPageSize={20}
    />
  );
}

export default LegacyMuiDatatable;
